import { render, staticRenderFns } from "./ExpandingDisclaimer.vue?vue&type=template&id=d5768c16&scoped=true"
import script from "./ExpandingDisclaimer.vue?vue&type=script&lang=js"
export * from "./ExpandingDisclaimer.vue?vue&type=script&lang=js"
import style0 from "./ExpandingDisclaimer.vue?vue&type=style&index=0&id=d5768c16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5768c16",
  null
  
)

export default component.exports